import { bootstrapApplication } from '@angular/platform-browser';
import '@vivest-dev/design-system-web-components';
import '@vivest-dev/design-system-web-components/tokens.css';
import '@vivest-dev/design-system-web-components/utilities.css';
import { appConfig } from './app/app.config';
import { App } from './app/app';

bootstrapApplication(App, appConfig)
  .catch((err) => console.error(err));
